export function buildTerminalUrl(gateway: string, sessionId: string, clientId: string): string {
  const url = new URL(gateway);
  url.searchParams.set('sessionId', sessionId);
  url.searchParams.set('clientId', clientId);
  return url.toString();
}
